import React from 'react'
import {useRoutes} from './routes'
import {BrowserRouter as Router} from 'react-router-dom'
import {GoogleOAuthProvider} from '@react-oauth/google'
import {useAuth} from './hooks/auth.hook'
import {AuthContext} from './context/AuthContext'
import {Navbar} from './elements/Navbar'
import {Footer} from './components/Footer'
import {LoaderClass} from './elements/LoaderClass'
import {contextMenuOff, objectLang, replaceLangUrl} from './functions'
import 'materialize-css'
import {HtmlLangSetter} from "./HtmlLangSetter"

function App() {
    const {
        superUser,
        rootFolder,
        avatarLink,
        accessToken,
        refreshToken,
        login,
        logout,
        userId,
        ready,
        nickName,
        language,
        authenticatedVia,
        deviceId,
        email
    } = useAuth()

    const isAuthenticated = !!accessToken
    const routes = useRoutes(isAuthenticated)
    replaceLangUrl()

    if (!ready) {
        return <LoaderClass/>
    }

    const lang = objectLang().language

    return (
        <div className={'app'}>
            <Router future={{v7_relativeSplatPath: true}}>
                <GoogleOAuthProvider clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}>
                    <AuthContext.Provider value={{
                        superUser,
                        rootFolder,
                        avatarLink,
                        accessToken,
                        refreshToken,
                        login,
                        logout,
                        userId,
                        isAuthenticated,
                        nickName,
                        language,
                        authenticatedVia,
                        deviceId,
                        email
                    }}>
                        <HtmlLangSetter />
                        <Navbar id={'navbar'} />
                        <div id="main-field" className={"col-12 content"} onWheel={contextMenuOff}>
                            {routes}
                        </div>
                        <Footer lang={lang} />
                    </AuthContext.Provider>
                </GoogleOAuthProvider>
            </Router>
        </div>
    )
}

export default App
